import {FinancingCompositionLayer} from '@dms/api/shared';

export const hasPhotoLayer = (layers: FinancingCompositionLayer[]) =>
  layers.some((layer) => layer.type === 'photo');
